import { CustomIotDeviceGroup, IotDisplayTab } from "./iot-types";

export const iotConfigType = {
  DISPLAY_SPACE: "display-space",
  DISPLAY_DEVICE_CONTROL: "display-device-control",
} as const;

export const iotConfigUseTab = {
  DEFAULT_TAB: "DEFAULT_TAB",
  CUSTOM_TAB: "CUSTOM_TAB",
} as const;

export type UnionIotConfigType = (typeof iotConfigType)[keyof typeof iotConfigType];

export type UnionIotConfigUseTab = (typeof iotConfigUseTab)[keyof typeof iotConfigUseTab] | "";

export interface IotPartnerConfig {
  type: UnionIotConfigType;
  useTabs: UnionIotConfigUseTab[];
}

export type IotConfigResponse = {
  partnerId: string;
} & IotPartnerConfig;

export interface IotCustomTabRequest {
  name: string;
  priority: number;
  configType?: UnionIotConfigType;
}

// export type IotTabFormData = CustomIotDeviceGroup & { originalId?: string };
export type IotTabFormData = IotDisplayTab & { originalId?: string };
